<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';
import CountdownSquare from './CountdownSquare.vue';

const props = defineProps({
  currentTime: Object,
  endTime: String,
});

const calcUnit = (unit, secondsPerUnit) => ({ units, seconds }) => {
  const unitCount = Math.floor(seconds / secondsPerUnit);
  const remainingSeconds = seconds % secondsPerUnit;
  return {
    units: { ...units, [unit]: unitCount > 0 ? unitCount : 0 },
    seconds: remainingSeconds,
  };
};

const parseUnits = (differenceInSeconds) => [
  calcUnit('day', 86400),
  calcUnit('hour', 3600),
  calcUnit('minute', 60),
  calcUnit('second', 1),
].reduce((acc, x) => x(acc), { units: {}, seconds: differenceInSeconds });

const differenceInSeconds = computed(() => dayjs(props.endTime).diff(dayjs(props.currentTime), 'second'));

const units = computed(() => parseUnits(differenceInSeconds.value).units);

</script>
<template>
  <div class="flex">
    <countdown-square unit="Days" :count="units?.day" />
    <div
      class="
        tablet:text-[2rem]
        flex flex-col justify-center
        px-[0.5rem] tablet:px-[1rem]
      "><span>:</span></div>
    <countdown-square unit="Hours" :count="units?.hour" />
    <div
      class="
        tablet:text-[2rem]
        flex flex-col justify-center
        px-[0.5rem] tablet:px-[1rem]
      "><span>:</span></div>
    <countdown-square unit="Minutes" :count="units?.minute" />
    <div
      class="
        tablet:text-[2rem]
        flex flex-col justify-center
        px-[0.5rem] tablet:px-[1rem]
      "><span>:</span></div>
    <countdown-square unit="Seconds" :count="units?.second" />
  </div>
</template>
